var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobApplicationIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 325.722,
    height: 264.547,
    viewBox: "0 0 325.722 264.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "job_application_icon3",
    transform: "translate(79.218 -5409.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172484",
    "data-name": "\\uADF8\\uB8F9 172484",
    transform: "translate(113.709 5400.924) rotate(60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121619",
    "data-name": "\\uD328\\uC2A4 121619",
    d: "M3529.145,2289.786c-20.82,24.39-98.748,74.954-98.748,74.954s69.6,36.287,74.954,129.085c63.649-29.147,111.239-57.7,111.239-57.7S3620.754,2364.145,3529.145,2289.786Z",
    transform: "translate(-3430.397 -2271.052)",
    fill: "#d7e0ec",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172488",
    "data-name": "\\uADF8\\uB8F9 172488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121620",
    "data-name": "\\uD328\\uC2A4 121620",
    d: "M3543.439,2261.2c-20.819,24.39-98.748,74.953-98.748,74.953s69.6,36.287,74.954,129.087c63.65-29.148,111.239-57.7,111.239-57.7S3635.049,2335.555,3543.439,2261.2Z",
    transform: "translate(-3435.324 -2261.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121621",
    "data-name": "\\uD328\\uC2A4 121621",
    d: "M3566.425,2301.441q-18,12.967-35.9,26.063c-5.907,4.318-11.771,8.695-17.647,13.056-5.793,4.3-11.924,8.394-17.139,13.4a.909.909,0,0,0,1.1,1.422c6.393-3.46,12.189-8.079,18.084-12.309,5.939-4.26,11.886-8.507,17.793-12.81q17.736-12.921,35.385-25.959C3569.789,2303.054,3568.168,2300.186,3566.425,2301.441Z",
    transform: "translate(-3452.827 -2274.962)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121622",
    "data-name": "\\uD328\\uC2A4 121622",
    d: "M3584.74,2327.469c-12.063,7.858-23.989,15.944-35.946,23.964-5.914,3.967-11.795,7.98-17.691,11.973-3.018,2.042-6.055,4.056-9.042,6.145-2.725,1.9-5.86,3.726-8.12,6.19-.543.592-.021,1.77.846,1.454,3.144-1.149,5.973-3.282,8.777-5.074,3.067-1.96,6.087-4,9.125-6,5.938-3.921,11.892-7.818,17.813-11.766,11.982-7.985,24.015-15.918,35.889-24.063C3588.107,2329.113,3586.518,2326.309,3584.74,2327.469Z",
    transform: "translate(-3459.119 -2283.947)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121623",
    "data-name": "\\uD328\\uC2A4 121623",
    d: "M3604.932,2350.225q-18.413,11.916-36.772,23.909-9.192,5.986-18.353,12.017c-2.915,1.918-5.84,3.825-8.728,5.786-2.951,2-6.1,3.9-8.5,6.58-.492.553-.027,1.573.766,1.315,3.253-1.051,6.092-2.992,8.968-4.79,3.1-1.939,6.162-3.929,9.232-5.912q9.211-5.95,18.4-11.94,18.368-11.989,36.719-24C3608.5,2351.981,3606.8,2349.019,3604.932,2350.225Z",
    transform: "translate(-3465.552 -2291.788)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121624",
    "data-name": "\\uD328\\uC2A4 121624",
    d: "M3624.027,2383.059c-.691.132-1.355-.2-2.027-.022a11.791,11.791,0,0,0-2.179,1.1q-2.653,1.383-5.3,2.771-5.073,2.672-10.14,5.355l-20.72,10.946q-10.138,5.355-20.255,10.751c-6.657,3.571-14.065,6.817-19.86,11.729-.472.4.035,1.151.583,1,7.2-1.968,13.946-6.185,20.529-9.6q10.4-5.4,20.756-10.885l20.288-10.694q5.292-2.789,10.586-5.58c1.763-.931,3.521-1.874,5.279-2.812a9.206,9.206,0,0,0,1.933-1.073c.553-.521.685-1.21,1.239-1.764A.735.735,0,0,0,3624.027,2383.059Z",
    transform: "translate(-3469.335 -2303.178)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121625",
    "data-name": "\\uD328\\uC2A4 121625",
    d: "M3642.363,2414.986c-12.693,6.425-25.116,13.448-37.652,20.173q-9.19,4.932-18.364,9.9c-6.082,3.281-12.818,6.216-18.245,10.535-.689.549.058,1.707.846,1.453,6.457-2.076,12.509-5.993,18.472-9.17q9.425-5.023,18.847-10.053c12.539-6.718,25.266-13.179,37.641-20.195C3645.628,2416.648,3644.108,2414.1,3642.363,2414.986Z",
    transform: "translate(-3477.771 -2314.146)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121626",
    "data-name": "\\uD328\\uC2A4 121626",
    d: "M3657.915,2450.957q-18.582,9.9-37.149,19.814c-6.038,3.233-12.1,6.431-18.112,9.706-3.08,1.677-6.177,3.33-9.228,5.058-2.886,1.635-6.2,3.151-8.542,5.543a.616.616,0,0,0,.595,1.021c3.147-.581,6.137-2.406,8.979-3.809,3.147-1.555,6.248-3.208,9.364-4.823,6.23-3.228,12.415-6.549,18.62-9.829q18.611-9.842,37.193-19.738C3661.573,2452.871,3659.854,2449.925,3657.915,2450.957Z",
    transform: "translate(-3483.588 -2326.534)",
    fill: "#d7e0ec"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171914",
    "data-name": "\\uADF8\\uB8F9 171914",
    transform: "translate(32.685 5585.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail_icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-2",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-3",
    "data-name": "mail_icon",
    transform: "translate(26.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-4",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-5",
    "data-name": "mail_icon",
    transform: "translate(53.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-6",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-7",
    "data-name": "mail_icon",
    transform: "translate(80.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-8",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-9",
    "data-name": "mail_icon",
    transform: "translate(107.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-10",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-11",
    "data-name": "mail_icon",
    transform: "translate(133.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-12",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-13",
    "data-name": "mail_icon",
    transform: "translate(160.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-14",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-15",
    "data-name": "mail_icon",
    transform: "translate(187.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-16",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-17",
    "data-name": "mail_icon",
    transform: "translate(0 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-18",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-19",
    "data-name": "mail_icon",
    transform: "translate(26.759 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-20",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-21",
    "data-name": "mail_icon",
    transform: "translate(53.516 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-22",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-23",
    "data-name": "mail_icon",
    transform: "translate(80.273 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-24",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-25",
    "data-name": "mail_icon",
    transform: "translate(107.03 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-26",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-27",
    "data-name": "mail_icon",
    transform: "translate(133.789 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-28",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-29",
    "data-name": "mail_icon",
    transform: "translate(160.546 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-30",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-31",
    "data-name": "mail_icon",
    transform: "translate(187.303 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-32",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-33",
    "data-name": "mail_icon",
    transform: "translate(0 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-34",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-35",
    "data-name": "mail_icon",
    transform: "translate(26.759 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-36",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-37",
    "data-name": "mail_icon",
    transform: "translate(53.516 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-38",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-39",
    "data-name": "mail_icon",
    transform: "translate(80.273 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-40",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-41",
    "data-name": "mail_icon",
    transform: "translate(107.03 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-42",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-43",
    "data-name": "mail_icon",
    transform: "translate(133.789 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-44",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-45",
    "data-name": "mail_icon",
    transform: "translate(160.546 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-46",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-47",
    "data-name": "mail_icon",
    transform: "translate(187.303 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-48",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobApplicationIcon3);
export default __webpack_public_path__ + "static/media/job_application_icon3.df2e6ac2bbc34f34d0b6b2801958a528.svg";
export { ForwardRef as ReactComponent };